/**
 * @generated SignedSource<<a11331e50ea9bc27dc3e5582ea24056c>>
 * @relayHash 5d92afcae44c41d812080f4c5cba9de9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f4a788c66d133695225f198344d090ebb2635c6c5bc51621d02fcc1641ad3d27

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$data = {
  readonly space: {
    readonly alias: string | null | undefined;
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
  readonly webItemSections: ReadonlyArray<{
    readonly cacheKey: string | null | undefined;
    readonly id: string | null | undefined;
    readonly items: ReadonlyArray<{
      readonly completeKey: string | null | undefined;
      readonly icon: {
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly label: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined>;
    readonly label: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery = {
  response: useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$data;
  variables: useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "label"
},
v4 = [
  {
    "args": [
      (v1/*: any*/),
      {
        "kind": "Literal",
        "name": "location",
        "value": "system.space.tools"
      }
    ],
    "concreteType": "WebSection",
    "kind": "LinkedField",
    "name": "webItemSections",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "cacheKey"
      },
      {
        "concreteType": "WebItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "completeKey"
          },
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "5d92afcae44c41d812080f4c5cba9de9",
    "id": "f4a788c66d133695225f198344d090ebb2635c6c5bc51621d02fcc1641ad3d27",
    "metadata": {},
    "name": "useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery",
    "operationKind": "query",
    "text": "query useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery($spaceKey:String){webItemSections(location:\"system.space.tools\",key:$spaceKey){id,label,cacheKey,items{id,completeKey,label,url,icon{path}}},space(key:$spaceKey){alias,id,key,currentUser{isAdmin}}}"
  }
};
})();

(node as any).hash = "ac644bf197ef5f2ffa2aff7f09be22b4";

export default node;
